import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, halfWidth } from "../../blocks/layout/columnSpans";

/**
 * Ticket Hospitality Product as page config. The ticketing feed owns everything but the
 * hospitality flag, so the rest is shown and never saved back.
 */
export const ticketHospitalityProductPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "dwtickethospitalityproduct",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 9, mobile: 12 },
          blocks: [
            {
              kind: "section",
              id: "section-ticket-hospitality-product",
              title: "Product details",
              fields: [
                {
                  id: "field-source",
                  type: "text",
                  name: "source",
                  label: "Source",
                  readOnly: true,
                  excludeFromSave: true,
                  span: halfWidth,
                },
                {
                  id: "field-producttype",
                  type: "text",
                  name: "producttype",
                  label: "Product Type",
                  readOnly: true,
                  excludeFromSave: true,
                  span: halfWidth,
                },
                {
                  id: "field-averageprice",
                  type: "money",
                  name: "averageprice",
                  label: "Average Price",
                  readOnly: true,
                  excludeFromSave: true,
                  span: halfWidth,
                },
                {
                  id: "field-ticketcount",
                  type: "number",
                  name: "ticketcount",
                  label: "Ticket Count",
                  readOnly: true,
                  excludeFromSave: true,
                  span: halfWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 3, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-hospitality",
              title: "Hospitality",
              fields: [
                {
                  id: "field-ishospitality",
                  type: "boolean",
                  name: "ishospitality",
                  label: "Is Hospitality",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
